// extracted by mini-css-extract-plugin
module.exports = {"body":"ConfirmLoading_body__1IsNi","info":"ConfirmLoading_info__2KSYF","title":"ConfirmLoading_title__RBqQG","progress":"ConfirmLoading_progress__2afg9"};